/* App flow redirection */

import Settings from "./settings";
import User from "./user";
import { BehaviorSubject } from 'rxjs';
import Helpers from "./helpers";
import Storage from "./storage.service";
import CONSTANTS from "./constants.service";
import { createBrowserHistory } from 'history';
import { customPlanEligibleToPhoneAddOn, allowiPhonePurchase} from './vip.bundle.service';
import { moiPlanCheck } from "./plans.service";
import Products from "./products.service";
import Events from "./events.service";
const history = createBrowserHistory();

var Flow = {
	routeTo: null,
	loaded: false,
};

Flow.slash = "/";

let steps = [];
let paths = [];
Flow.starting_point = null;
var obsrv = new BehaviorSubject(Flow.routeTo);

var loaded = new BehaviorSubject(Flow.loaded);

let routes_source = "routes";
Flow.get_route = () => {
	return obsrv.asObservable();
};

Flow.getCurrentRoute = () => {
	return Flow.routeTo;
};

Flow.isRouteAFullURL = (route = "") => {
	return route.indexOf("http:/") !== -1 || route.indexOf("https:/") !== -1;
};

Flow.get_load_status = () => {
	return loaded.asObservable();
};

if (Settings.enable_history) {
	history.listen(({ action, location }) => {
		if(Helpers.isExceptionRoute()){
			if (window.location.href.indexOf("/installment-success") !== -1) {
				Flow.goTo("/installment-success");
			}
			if (window.location.href.indexOf("/installment-fail") !== -1) {
				Flow.goTo("/installment-fail");
			}
			if (window.location.href.indexOf("/contract-request") !== -1) {
				let url_params = Helpers.getParams();
				let session_id_param = url_params.pieces['session-id'] ? `?session-id=${url_params.pieces['session-id']}` : '';
				Flow.goTo(`/contract-request${session_id_param}`);
			}
		} else {
			let location_from_url = location.hash.substring(1, location.hash.length);
			Flow.goTo(location_from_url);
		}
	});
}

Flow.mapSubs = (steps) => {
	let f = {};
	if (steps.length >= 1) {
		for (let step of steps) {
			if (step.subs && step.subs.length >=1 ){
				for (let sub of step.subs) {
					f[sub] = { path: step.path, order: step.order, key: step.key };
				}
			}
		}
		return f;
	}
};

Flow.getStepBaseOf = (current) => {
	if (Flow.routes[current]) {
		return Flow.routes[current]["path"];
	} else {
		return -1;
	}
};

Flow.goToStepBase = (current) => {
	if (Flow.routes[current]) {
		Flow.goToRouteWithChecks(Flow.routes[current]["path"]);
	} else {
		let recommended = Flow.getRecommendedRoute(8);
		Flow.goToRouteWithChecks(recommended);
	}
};

Flow.goToRouteWithChecks = (route) => {
	if (Flow.isRouteAFullURL(route)) {
		Flow.goToHref(route);
	} else {
		Flow.goTo(route);
	}
	// let flags = Storage.get("flow_status_flags");
	// let isPlanSelected = flags.is_plan_selected;
	// log url once changed , but not first page load [changed]:
	// if(isPlanSelected){
	Events.when_user_loads_page();
};

Flow.goTo = (route = null) => {
	if (!route || !Flow.isRouteAllowed(route, "2")) {
		route = Flow.getRecommendedRoute(9);
	}

	if (route !== Flow.routeTo) {
		if (Flow.routeTo !== null) {
			Storage.set("navigating_within_app", true);
		}
		if (Flow.isRouteAFullURL(route)) {
			Flow.goToHref(route);
		} else {
			Flow.routeTo = route;
			obsrv.next(Flow.routeTo);
		}
	}
};

Flow.goToHref = (route) => {
	window.location.href = route;
};

Flow.goToStart = () => {
	Flow.goTo(Flow.starting_path["path"]);
};

Flow.checkBack = (current) => {
	return Flow.stepNumberOf(current) > 1;
};

Flow.numberIsFirstStep = () => {
	return Flow.routes && Flow.routes["number"] && Flow.routes["number"]["order"] === 1;
};

Flow.isRouteAllowed = (route, callee = null) => {
	let allowed = false;
	let flags = Storage.get("flow_status_flags");
	let numberSelected = flags?.is_number_selected;
	let loggedIn = User.isLoggedInProper();
	let resident = Storage.get("is_resident", true);

	if (route === "/minors"){
		return true;
	}

	let number_required_for_plan =
		!Flow.numberIsFirstStep() ||
		(Flow.numberIsFirstStep() && flags.is_number_selected);


	if (route === "/activation_method" || 
		route === "/activation_method/scan_face" ||
		route === "/activation_method/scan_document" || 
		route === "/activation_method/upload_document"
	){
		if (!Storage.get("businessConfig")?.enable_moi_passport){
			return false;
		}
		if (resident === CONSTANTS.RESIDENT) return false;
		let ifPlanCanUseMoiActivation = moiPlanCheck(); 
		if (numberSelected && loggedIn && ifPlanCanUseMoiActivation) {
			return true;
		} else {
			Storage.set("moi-esim-instant-activation-enabled", false, true);
			return false;
		}
	}

	if (route.includes("/contract-request")) {
		return true;
	}
	if (User.isLoggedIn() && flags) {
		let done = Flow.isDone();
		if (route === "/plan-offer"){
			if (!done && flags.is_plan_selected) {
				allowed = Products.allowProductUpsell();
			}
		}
		if (route === "/device-selection"){
			if (flags?.is_plan_paid) return false;
			if (!done && flags.is_plan_selected){
				allowed = customPlanEligibleToPhoneAddOn();
			}
		}
		if (route === "/choose-your-iphone" && allowiPhonePurchase(flags)){
			allowed= true;
		}

		if (route === Flow.getStepBaseOf("thank_you")) {
				if((Storage.get('registration_type') === "Facebook" || 
							Storage.get('registration_type') === "Google") && 
							(flags.is_plan_paid && User.isLoggedInProper())){
								Flow.goToHref(`${window.location.origin}/app`)
						}
					else if(done || (flags.is_plan_paid && User.isLoggedInProper())) {
						allowed = true;
					}
		}

		if (route === "/terminated") {
			if (
				!(flags.is_logged_in_via_email && flags.has_password) &&
				Storage.get("terminated_email")
			) {
				allowed = true;
			}
		}

		if (route === Flow.getStepBaseOf("account")) {
			if (
				flags.is_number_selected &&
				flags.is_plan_selected &&
				!(flags.is_logged_in_via_email && flags.has_password)
			) {
				allowed = true;
			}
		}

		if (
			route === Flow.getStepBaseOf("delivery") ||
			route === "/delivery-closed"
		) {
			let residency_info = Storage.get("is_resident", true);
			// let residency_info = Storage.get("is_resident");
			let is_resident = residency_info && residency_info === CONSTANTS.RESIDENT;
			if (!done && !Storage.get("selected_store_pickup", true) && !Storage.get("delivery_form", true) && User.isLoggedInProper() && is_resident) {
				allowed = true;
			}
		}
		
		if (route === Flow.getStepBaseOf("submit_delivery")) {
			let residency_info = Storage.get("is_resident", true);
			// let residency_info = Storage.get("is_resident");
			let is_resident = residency_info && residency_info === CONSTANTS.RESIDENT;

			if (
				!done &&
				Storage.get("delivery_form", true) &&
				User.isLoggedInProper() &&
				is_resident
			) {
				allowed = true;
			}
		}

		if (route === "/installment-fail") {
			if (
				!done &&
				!flags.is_plan_paid &&
				User.isLoggedInProper()
			) {
				allowed = true;
			}
		}

		if (route === "/installment-success") {
			if (
				!done &&
				User.isLoggedInProper()
			) {
				allowed = true;
			}
		}

		if (route === Flow.getStepBaseOf("payment") 
			|| route === "/instalments") {
			let residency_info = Storage.get("is_resident", true);
			if (
				!done &&
				!flags.is_plan_paid &&
				flags.is_number_selected &&
				flags.is_plan_selected &&
				User.isLoggedInProper() &&
				residency_info
			) {
				allowed = true;
			}
		}

		if (route === Flow.getStepBaseOf("plan") || route === "/custom-plan") {
			if (!done && !flags.is_plan_paid && number_required_for_plan) {
				allowed = true;
			}
		}

		if (
			route === Flow.getStepBaseOf("number") ||
			route.indexOf("/number/") !== -1
		) {
			if (!done && !flags.is_plan_paid) {
				allowed = true;
			}
		}

		if (
			route === Flow.getStepBaseOf("id_check")
		) {
			// let residency_info = Storage.get("is_resident", true);
			let residency_info = Storage.get("is_resident", true);
			if(flags.is_plan_selected && flags.is_number_selected && (!flags.is_plan_paid) && !done && !residency_info){
				allowed = true;
			}
		}

		if(route === "/residency" && flags?.is_plan_paid) return false;
		if(route === "/residency" && flags?.is_logged_in && !Storage.get("locationIsPicked",true) && !Storage.get("delivery_form",true)){
			allowed = true;
		}

	}

	if (route === Flow.slash || route === "/number/search") {
		allowed = true;
	}

	return allowed;
};

Flow.back = (current) => {
	let route = "";
	if (current) {
		route = Flow.getPrevRouteOf(current);

		if (!Flow.isRouteAllowed(route, "433")) {
			let current_order = Flow.stepNumberOf(current);
			if (Flow.steps[current_order - 1]) {
				route = Flow.getPrevRouteOf(Flow.steps[current_order - 1]["key"]);
				// Flow.steps[current_order + 2]["path"];
			} else {
				route = Flow.getRecommendedRoute(13332);
			}
		}
	} else {
		route = Flow.getRecommendedRoute(1231);
	}

	Flow.goToRouteWithChecks(route);
};

Flow.next = (current) => {
	let route = "";
	if (current) {
		route = Flow.getNextRouteOf(current);

		if (!Flow.isRouteAllowed(route, "4")) {

			let current_order = Flow.stepNumberOf(current);

			if (Flow.steps[current_order + 1]) {
				route = Flow.getNextRouteOf(Flow.steps[current_order + 1]["key"]);

				// Flow.steps[current_order + 2]["path"];
			} else {
				route = Flow.getRecommendedRoute(132);
			}
		}
	} else {
		route = Flow.getRecommendedRoute(11);
	}

	Flow.goToRouteWithChecks(route);
};

Flow.getNextRouteOf = (current) => {
	let route = Flow.slash;
	if (Flow.routes[current]) {
		let current_index = Flow.routes[current]["order"];
		route = Flow.steps[current_index + 1 + ""]
			? Flow.steps[current_index + 1 + ""]["path"]
			: Flow.steps[current_index + ""]["path"];
	} else {
		route = Flow.getRecommendedRoute(12);
	}
	return route;
};

Flow.getPrevRouteOf = (current) => {
	let route = Flow.slash;
	if (Flow.routes[current]) {
		let current_index = Flow.routes[current]["order"];
		route = Flow.steps[current_index - 1 + ""]
			? Flow.steps[current_index - 1 + ""]["path"]
			: Flow.steps[current_index + ""]["path"];
	} else {
		route = Flow.getRecommendedRoute(13);
	}
	return route;
};

Flow.getStepNameByPath = (path) => {
	if (Flow.paths[path]) {
		let step = Flow.paths[path]["key"];
		return step;
	}
	if (Flow.sub_paths[path]) {
		let order = Flow.sub_paths[path]["key"];
		return order;
	}
	return "";
};

Flow.isSubPath = (path) => {
	if (Flow.sub_paths[path]) {
		return true;
	}
	if (path.indexOf("vip-") !== -1) {
		return true;
	}
	return false;
};

Flow.pathNumberOf = (path) => {
	if(path){
		if (Flow.paths[path]) {
			let step = Flow.paths[path]["order"];
			return step;
		}
		if (Flow.sub_paths[path]) {
			let order = Flow.sub_paths[path]["order"];
			return order;
		}
	}
	return 1;
};

Flow.stepNumberOf = (current) => {
	if (Flow.routes[current]) {
		let step = Flow.routes[current]["order"];
		return step;
	}
	return 0;
};

Flow.hasPaidOrMore = (flags = null) => {
	if(!flags){
		flags = Storage.get("flow_status_flags");
	}
	return (
		flags &&
		(flags.is_plan_paid ||
			flags.is_sim_delivered ||
			flags.is_delivery_in_progress ||
			flags.is_sim_activated)
	);
};

Flow.isDone = () => {
	let flags = Storage.get("flow_status_flags");
	if (Storage.get("is_resident",true) === CONSTANTS.NON_RESIDENT){
		return (flags && flags.is_plan_paid);
	}
	return (
		flags &&
		(flags.is_sim_delivered ||
			flags.is_delivery_in_progress ||
			flags.is_sim_activated)
	);
};

Flow.getRecommendedRoute = (callee = "default") => {
	let flags = Storage.get("flow_status_flags");
	let routeTo = null;
	let done = Flow.isDone();
	let navigating_within_app = Storage.get("navigating_within_app");

	if (Storage.get("filter_vip") || Storage.get("search")) {
		routeTo = "/number/search";
	} else {
		if (flags) {
			if (done) {
				routeTo = Flow.getStepBaseOf("thank_you");
			} else {
				let last_allowed = Flow.slash;

				let number_pending = flags.is_number_selected && !flags.is_plan_paid;
				let number_base = Flow.getStepBaseOf("number");

				let go_to_stored_number_on_entry =
					number_pending &&
					!navigating_within_app &&
					Flow.getCurrentRoute() !== number_base &&
					!Storage.get("number_confirmed_on_entry");

				if (go_to_stored_number_on_entry) {
					last_allowed = number_base;
				} else {
					Storage.clear("number_confirmed_on_entry");
					for (let step of Object.keys(Flow.steps)) {
						let path = Flow.steps[step]["path"];
						if (Flow.isRouteAllowed(path, "5")) {
							let skip_it = false;
							if (Flow.steps[step]["skip_flag"]) {
								for (let skipper of Flow.steps[step]["skip_flag"]) {
									if (Storage.get("isComingFromGroupInvitation", true) && skipper["order"] !== null) {
										skip_it = true;
										break;
									}
									else if (flags[skipper] || Storage.get(skipper, true)) {
										skip_it = true;
									} else {
										skip_it = false;
										break;
									}
								}
							}

							if (skip_it) {
								continue;
							}

							last_allowed = path;

							break;
						}
					}
				}

				routeTo = last_allowed;
			}
		} else {
			routeTo = Flow.slash;
		}
	}
	return routeTo;
};

Flow.goHome = () => {
	Flow.goTo(Flow.slash);
};
Flow.init = () => {

	for (let step in Settings[routes_source]) {
		steps.push(Settings[routes_source][step]);
		paths.push(Settings[routes_source][step]);
	}
	Flow.routes = Settings[routes_source];
	Flow.steps_count = steps.length;

	steps = steps.sort((a, b) => {
		return a.order - b.order;
	});

	steps = steps.map((item, index) => {
		item["order"] = index + 1;
		return item;
	});

	Flow.steps = Helpers.arrayToObject(steps, "order");

	Flow.starting_path = steps[0];

	Flow.paths = Helpers.arrayToObject(steps, "path");
	Flow.sub_paths = Flow.mapSubs(steps);

	Flow.loaded = true;

	obsrv.next(Flow.routeTo);
	loaded.next(Flow.loaded);
};

export default Flow;
